<script setup>
import { StealieHeading, StealieButton } from "@get-overalls/fe-stealie";
import ContentPanel from "@/components/ContentPanel.vue";
import RequestsList from "@/components/RequestsList.vue";
import AuthenticatedLayout from "@/layouts/AuthenticatedLayout.vue";
import { useRequestSurveyStore } from "@/stores/requestSurvey";
const requestSurveyStore = useRequestSurveyStore();
</script>

<template>
  <AuthenticatedLayout>
    <ContentPanel data-sr-unmask>
      <header class="relative flex items-center justify-between">
        <StealieHeading level="1" size="lg">Requests</StealieHeading>
        <div class="hidden lg:block">
          <StealieButton class="!my-0" @click="requestSurveyStore.openCategoryDrawer()">
            Create a request
          </StealieButton>
        </div>
      </header>
      <RequestsList @create-request="requestSurveyStore.openCategoryDrawer()" />
    </ContentPanel>
  </AuthenticatedLayout>
</template>
